import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { SkillInfo } from "../User";

const SkillsMasonry = () => {
  return (
    <section
      id="Skills"
      className="w-[80vw] mx-auto px-6 py-16 font-mono sm:w-[90vw]"
    >
      <h1 className="text-3xl sm:text-3xl font-bold text-center text-white mb-10">
        <span className="text-primaryColor">03.&nbsp;</span>Skills
      </h1>

      {/* Masonry Grid — responsive, compact, centered */}
      <div className="columns-1 sm:columns-2 md:columns-3 lg:columns-4 space-y-4">
        {SkillInfo.map((skill, index) => (
          <SkillCard key={index} title={skill.title} skills={skill.skills} />
        ))}
      </div>
    </section>
  );
};

/* ---------------- Icon Map (currently unused) ---------------- */
// const ICON_MAP: Record<string, string> = {
//   html: "html5.png",
//   css: "CSS.png",
//   javascript: "javascript.png",
//   typescript: "typescript.png",
//   react: "react.png",
//   redux: "redux.png",
//   tailwind: "tailwind.png",
//   bootstrap: "bootstrap.png",
//   node: "nodejs.png",
//   express: "express.png",
//   mongodb: "mongodb.png",
//   mysql: "mysql.png",
//   postgresql: "postgresql.png",
//   firebase: "firebase.png",
//   docker: "docker.png",
//   git: "git.png",
//   github: "github.png",
//   aws: "amazonaws.png",
//   redis: "redis.png",
//   kafka: "kafka.png",
//   python: "python.png",
//   cpp: "C++.png",
//   c: "c.png",
// };

// const FALLBACK_ICON = "Icons/fallback.png"; // universal fallback
// const getIconPath = (skill: string): string => {
//   const key = skill.toLowerCase().replace(/\s+/g, "").replace(/\./g, "");
//   return ICON_MAP[key] ? `Icons/${ICON_MAP[key]}` : FALLBACK_ICON;
// };

/* ---------------- Skill Card ---------------- */
const SkillCard = ({
  title,
  skills,
}: {
  title: string;
  skills: string[];
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 25 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.4, ease: "easeOut" }}
      whileHover={{ scale: 1.03 }}
      className="inline-block w-full bg-[#0a0f1c]/80 border border-primaryColor/30
                 rounded-xl p-4 backdrop-blur-sm hover:border-primaryColor/70
                 transition-all duration-300 break-inside-avoid shadow-[0_0_10px_#64FFDA20]"
    >
      <h2 className="text-lg font-semibold text-white text-center mb-3">
        {title}
      </h2>
      <div className="flex flex-wrap justify-center gap-2">
        {skills.map((skill, i) => (
          <div
            key={i}
            className="px-3 py-1.5 bg-[#101827]/60 border border-white/10 
                       rounded-md hover:border-primaryColor/60 
                       transition-all duration-200 text-xs text-gray-300 
                       font-medium cursor-default"
          >
            {/* Icon temporarily disabled
            <img
              src={getIconPath(skill)}
              alt={skill}
              onError={(e) =>
                ((e.target as HTMLImageElement).src = FALLBACK_ICON)
              }
              className="w-4 h-4 object-contain"
            />
            */}
            {skill}
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default SkillsMasonry;
